function getPerformanceData() {
  var t = performance.timing;
  var ts = {};

  // 页面加载完成的时间。 tab 上转菊花
  ts.pageload = t.loadEventEnd - t.navigationStart;

  // 解析 DOM 树结构的时间。 反省下你的 DOM 树嵌套是不是太多了！
  ts.dom = t.domComplete - t.responseEnd;

  // JS 脚本加载执行完毕，可以交互操作了
  ts.domready = t.domContentLoadedEventEnd - t.navigationStart;

  // DNS 查询时间
  // DNS 预加载做了么？页面内是不是使用了太多不同的域名导致域名查询的时间太长？
  // 可使用 HTML5 Prefetch 预查询 DNS
  // 见：[HTML5 prefetch](http://segmentfault.com/a/1190000000633364)
  ts.dns = t.domainLookupEnd - t.domainLookupStart

  // 首字节时间
  // TTFB 即 Time To First Byte 的意思
  // 加异地机房了么，加CDN 处理了么？加带宽了么？加 CPU 运算速度了么？
  ts.ttfb = t.responseStart - t.navigationStart;

  // 内容加载完成的时间
  // 页面内容经过 gzip 压缩了么，静态资源 css/js 等压缩了么？
  ts.request = t.responseEnd - t.requestStart;

  // 执行 onload 回调函数的时间
  // 是否太多不必要的操作都放到 onload 回调函数里执行了，考虑过延迟/按需加载的策略么？
  ts.onload = t.loadEventEnd - t.loadEventStart;

  return ts;
}

module.exports = function () {
 return getPerformanceData();
};


//////////////////
// WEBPACK FOOTER
// ./src/plugin/performance.js
// module id = 1
// module chunks = 0 1 2